// @owners { team: patients }
import {
  CouponsEndpoint,
  type CouponsEndpointFetchSignUpConfigurationResponse,
} from '@alto/scriptdash/alto/patient_app/billing/v1/coupons_endpoint';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { apiEndpointHandler } from '~shared/helpers/api';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';
import { staleTimes } from '~shared/queries/constants';

const couponsEndpoint = CouponsEndpoint(apiEndpointHandler);

const coupons = createQueryKeys('coupons', {
  signUpConfig: (couponID: number) => ({
    queryKey: ['sign-up-config', couponID],
    queryFn: async (): Promise<CouponsEndpointFetchSignUpConfigurationResponse> => {
      const response = await couponsEndpoint.fetchSignUpConfiguration({ coupon_id: couponID });
      if (response.errors) {
        throw new Error(getErrorMessageFromResponse({ errors: response.errors ?? undefined }));
      }

      return response;
    },
  }),
});

export const useGetCouponSignUpConfig = (couponID: number) => {
  const { data, error, isLoading } = useQuery({
    ...coupons.signUpConfig(couponID),
    enabled: !!couponID,
    staleTime: staleTimes.fiveMinutes,
  });

  return {
    isLoading,
    couponConfig: data?.data,
    error,
  };
};
